var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgExit(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "icon/S/sign_out_solid"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M21.7232 12.6742L15.0562 19.3412C14.4609 19.9365 13.4291 19.5198 13.4291 18.6666V14.8569H8.03205C7.50424 14.8569 7.07962 14.4323 7.07962 13.9045V10.0947C7.07962 9.56694 7.50424 9.14232 8.03205 9.14232H13.4291V5.33261C13.4291 4.48336 14.457 4.0627 15.0562 4.65797L21.7232 11.325C22.0923 11.698 22.0923 12.3012 21.7232 12.6742ZM9.61943 19.1428V17.5554C9.61943 17.2935 9.40513 17.0792 9.14321 17.0792H5.80971C5.1073 17.0792 4.53981 16.5117 4.53981 15.8093V8.18989C4.53981 7.48747 5.1073 6.91999 5.80971 6.91999H9.14321C9.40513 6.91999 9.61943 6.70569 9.61943 6.44377V4.85639C9.61943 4.59447 9.40513 4.38018 9.14321 4.38018H5.80971C3.70643 4.38018 2 6.08661 2 8.18989V15.8093C2 17.9126 3.70643 19.619 5.80971 19.619H9.14321C9.40513 19.619 9.61943 19.4047 9.61943 19.1428Z",
    fill: "#FF5630"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgExit);
export default __webpack_public_path__ + "static/media/exit.cc9ef1785ba8c0401774bc554867f0f7.svg";
export { ForwardRef as ReactComponent };